import { BrowserApiSupportService } from '../../services/browser-api-support/browser-api-support.service';
import { DEFAULT_COUNTDOWN_TIME_LENGTH } from './constants';
import { Signal, WritableSignal, computed, signal } from '@angular/core';

export class Counter {
  public finished: WritableSignal<boolean> = signal(true);
  public inProgress: Signal<boolean> = computed(() => !this.finished());
  public tick: WritableSignal<string> = signal(null);

  private countDownLength: number;
  private currentValueStart: number;
  private interval: number;
  private oneSecondTimeOut: number = 1000;

  constructor(
    private window: Window,
    private browserApi: BrowserApiSupportService
  ) {}

  public start(value?: number): void {
    if (this.browserApi.isServer()) {
      return;
    }

    this.setCountDownLength(value);

    this.finished.set(false);

    this.setTick();

    if (this.interval) {
      this.window.clearInterval(this.interval);
    }

    this.interval = this.window.setInterval(() => {
      if (--this.currentValueStart < 0) {
        this.end();
      }

      this.setTick();
    }, this.oneSecondTimeOut);
  }

  private setTick(): void {
    let minutes: string | number = Math.floor(this.currentValueStart / 60);
    let seconds: string | number = this.currentValueStart % 60;

    minutes = minutes < 10 ? `0${minutes}` : minutes;
    seconds = seconds < 10 ? `0${seconds}` : seconds;

    this.tick.set(`${minutes}:${seconds}`);
  }

  public end(): void {
    this.window.clearInterval(this.interval);
    this.interval = undefined;
    this.finished.set(true);
    this.currentValueStart = this.countDownLength;
  }

  private setCountDownLength(value: number): void {
    this.countDownLength = value || DEFAULT_COUNTDOWN_TIME_LENGTH;
    this.currentValueStart = this.countDownLength;
  }
}
